import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../../api';

const CustomerContext = createContext();

export const useCustomers = () => useContext(CustomerContext);

export const CustomerProvider = ({ children }) => {
  const [allCustomers, setAllCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

const fetchCustomers = async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem('token');
    const res = await API.get('/customers/', {
      headers: { Authorization: `Bearer ${token}` },
    });

const Customers = res.data.map(c => ({
  ...c,
  // remark parsing
  remark: typeof c.remark === 'string' ? JSON.parse(c.remark || '[]') : c.remark || [],

  // work_process_details parsing
  work_process_details: Array.isArray(c.work_process_details)
    ? c.work_process_details
    : typeof c.work_process_details === 'string'
      ? JSON.parse(c.work_process_details || '[]')
      : []
}));

    setAllCustomers(Customers);
  } catch (err) {
    console.error("Failed to fetch customers", err);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchCustomers();
  }, []);


  return (
    <CustomerContext.Provider value={{ allCustomers, setAllCustomers, fetchCustomers, loading }}>
      {children}
    </CustomerContext.Provider>
  );
};
